module.exports = __webpack_public_path__ + "images/embed/prev_arrow.png";